import {DocumentNode} from 'graphql';
import gql from 'graphql-tag';

import {doQuerySafe} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';

import {
  EquipmentConnectionIdQuery,
  EquipmentConnectionIdQueryVariables,
} from './__generated/EquipmentConnectionIdQuery';

export const EQUIPMENT_CONNECTION_ID_QUERY: DocumentNode = gql`
  query EquipmentConnectionIdQuery($id: StrictString!) @skipAudit @engComponent(name: INSTRUMENTS) {
    equipment(id: $id) {
      ... on EquipmentNode {
        id
        connectionId
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export async function getConnectionIdFromEquipment(
  equipmentId: string | null,
  adapterId?: string | null
): Promise<string | null> {
  if (equipmentId && adapterId) {
    const result = await doQuerySafe<EquipmentConnectionIdQuery, EquipmentConnectionIdQueryVariables>(
      {query: EQUIPMENT_CONNECTION_ID_QUERY},
      {
        variables: {
          id: equipmentId,
        },
      }
    );

    if (!isInaccessible(result.equipment)) {
      return result.equipment.connectionId || null;
    }
  }
  return null;
}
